import { Pipe, PipeTransform } from '@angular/core';
import { MonitoringAlarm } from '../models/monitoring-alarm';

@Pipe({
  name: 'hasZabbixUrl'
})
export class HasZabbixUrlPipe implements PipeTransform {

  transform(alarms: MonitoringAlarm[]): boolean {
    return alarms && alarms.length === 1 ? !!alarms.filter(alarm => alarm.type === 'zabbix-alarm' ).reduce((acc, alarm) => acc || !!alarm.zabbixURL, false) : false
  }

}
